import { db } from "../firebase/config";

const addTicket = (ticket: {
  email: string;
  code: string;
  code2?: string;
  firstname: string;
  lastname: string;
  type: string;
  order: string;
  status: string;
}) => {
  db.collection("tickets").doc(ticket.email).set(ticket, { merge: true });
};

export default addTicket;
